import { Container, Header } from 'semantic-ui-react'

const AdminProfile = () => (
  <Container id="adminPanel">
    <Header as="h2">Admin Profile</Header>
  </Container>
)

export default AdminProfile
